import { Capacitor } from "@capacitor/core";
import {
  AdMob,
  BannerAdSize,
  BannerAdPosition,
  RewardAdPluginEvents,
} from "@capacitor-community/admob";

/* ───────── Platform ───────── */
export const isNative = () => Capacitor.isNativePlatform();
export const isNativeApp = isNative;

/* ───────── Ad Unit IDs (PROD) ───────── */
const PROD_BANNER = "ca-app-pub-9883067210867151/9931458504";
const PROD_REWARD = "ca-app-pub-9883067210867151/8474018558";

/* ───────── Internal State ───────── */
let inited = false;
let bannerReady = false;
let rewardEarned = false;
let rewardDismissed = false;

/* ───────── Init ───────── */
export async function initAd() {
  if (!isNative() || inited) return;

  try {
    await AdMob.initialize({
      testingDevices: ["B527C48E2C00936C060BADAD9F5A1C4A"],
      initializeForTesting: false,
    });

    AdMob.addListener(RewardAdPluginEvents.Rewarded, () => {
      rewardEarned = true;
      console.log("[ADS] Reward Earned");
    });

    AdMob.addListener(RewardAdPluginEvents.Dismissed, () => {
      rewardDismissed = true;
      console.log("[ADS] Reward Dismissed");
    });

    inited = true;
    console.log("[ADS] Init Success");
  } catch (e) {
    console.error("[ADS] Init Error", e);
  }
}

/* ───────── Reward show (FINAL FIX) ───────── */
export async function showRewardedAndWait(): Promise<
  "rewarded" | "closed" | "failed"
> {
  if (!isNative()) return "rewarded";

  await initAd();

  rewardEarned = false;
  rewardDismissed = false;

  try {
    await new Promise((r) => setTimeout(r, 300));
    await AdMob.showRewardAd({
      adId: PROD_REWARD,
      isTesting: false,
    });

    return await new Promise((resolve) => {
      let waited = 0;
      const iv = setInterval(() => {
        waited += 200;

        if (rewardEarned) {
          clearInterval(iv);
          resolve("rewarded");
        } else if (rewardDismissed) {
          clearInterval(iv);
          resolve("closed");
        } else if (waited > 60000) {
          clearInterval(iv);
          resolve("failed");
        }
      }, 200);
    });
  } catch (e) {
    console.error("[ADS] Show Reward Error", e);
    return "failed";
  }
}

/* ───────── Banner ───────── */
export async function showBanner(
  pos: "top" | "bottom" = "bottom",
  margin = 64
) {
  if (!isNative()) return;
  await initAd();
  if (bannerReady) return;

  bannerReady = true;

  try {
    await AdMob.showBanner({
      adId: PROD_BANNER,
      adSize: BannerAdSize.ADAPTIVE_BANNER,
      position:
        pos === "top"
          ? BannerAdPosition.TOP_CENTER
          : BannerAdPosition.BOTTOM_CENTER,
      margin,
      isTesting: false,
    });
  } catch (e) {
    bannerReady = false;
  }
}

/* ───────── Hide Banner ───────── */
export async function hideBanner() {
  if (!isNative()) return;
  try {
    await AdMob.hideBanner();
    bannerReady = false;
  } catch {}
}

/* ───────── Compatibility ───────── */
export async function ensureBanner(
  pos: "top" | "bottom" = "bottom",
  margin = 64
) {
  return showBanner(pos, margin);
}
